import {
  DRAWING_TYPE,
  type DrawingType,
  useDrawingCanvas,
} from '@/providers/DrawingCanvasProvider';
import ToggleBlock, { ToggleOption } from '@/components/ToggleBlock';
import { EditIcon, PolygonIcon } from '@/icons';
import Slider from '@/components/Slider';
import EraserIcon from './EraserIcon';
import { classes } from './utils';

const { PEN, ERASER, POLYGON } = DRAWING_TYPE;

export default function SelectionControls() {
  const { cursor, updateCursor } = useDrawingCanvas();
  return (
    <div className={classes.wrapper}>
      <ToggleBlock<DrawingType>
        exclusive
        value={cursor.type}
        onChange={(type) => updateCursor({ type })}>
        {/*<ToggleOption value={CONTROLS.PAN}>*/}
        {/*  <PanIcon />*/}
        {/*</ToggleOption>*/}
        <ToggleOption value={POLYGON}>
          <PolygonIcon />
        </ToggleOption>
        <ToggleOption value={PEN}>
          <EditIcon />
        </ToggleOption>
        <ToggleOption value={ERASER}>
          <EraserIcon />
        </ToggleOption>
      </ToggleBlock>
      {[PEN, ERASER].includes(cursor.type) && (
        <Slider
          className={classes.slider}
          min={1}
          max={100}
          value={cursor.size}
          onChange={(size) => updateCursor({ size })}
        />
      )}
    </div>
  );
}
